var token = 'OVRV6953U3X62MT';
var caravans = {};
var makeFromTemplate = '';
var typeFromTemplate = '';
var typesFromTemplate = [];

if (typeof make !== 'undefined') {
  makeFromTemplate = make;
}


if (typeof caravanType !== 'undefined') {
  typeFromTemplate = caravanType;
} 

// default value of the dropdown if no config is provided
if (typeof caravanTypes !== 'undefined') {
  typesFromTemplate = caravanTypes;
} else {
  typesFromTemplate.push('NEW');
  typesFromTemplate.push('USED');
  typesFromTemplate.push('DEMO');
}

// functions used outside js file
caravans.init = init;
caravans.populateCache = populateVehiclesSessionStorage;

function init() {
  populateVehiclesSessionStorage(renderCaravans);
}

function renderCaravans() {
  setTimeout(() => {
    getAllCurrentStocksFromCache()
    .then(function (data) {      
      populateProductCards(data);
      populateDropdownValues(data);
    })
    .then(function () {
      search(typeFromTemplate, makeFromTemplate);
    })
    .catch((err) => console.log({err}));
  }, 2000);
};

function renderCaravanDetails(id) {
  document.getElementById("detail-container").innerHTML += `Loading...`;
  getVehicleFullDetails(id, true).then(function(details) {
 	const html = getCaravanDetailsHtml(details);
    document.getElementById("detail-container").innerHTML = ``;
    document.getElementById("detail-container").innerHTML += html;  
  })
  .catch((err) => console.log({err}));
}

function getCaravanDetailsHtml(details) {
    const vehicleDetails = details.vehicle;
  	const acccessoriesHTML = getVehicleAccessoriesHTML(details.accessories);
  
    var price = vehicleDetails.driveawayPrice;
    var priceType = 'Drive Away No More To Pay';

    if (vehicleDetails.driveawayPrice.length === 0) {
      price = vehicleDetails.egcPrice;
      priceType = 'Excl. Govt. Charges';
    }  
  
  	var imgCarouselHTMLSingle = '';
  
    for (i = 1; i<=details.images.images.length - 1; i++) {
		
      imgCarouselHTMLSingle += `
          <div class="carousel-item">
              <img class="d-block w-100" src="` + details.images.images[i] + `" alt="Second slide">
          </div>
          `
    }
  
  
  	var imgCarouselHTML = 
        `<div class="carousel-item active"><img class="d-block w-100" src="` + getAVehiclesThumbnailUrlFullSize(vehicleDetails.id) + `" alt="First slide"></div>` + imgCarouselHTMLSingle;
 
  
  if (details.images.count === 0) {
    imgCarouselHTML =
    
`
                      <div class="carousel-item active" style="height: 30rem;">
                        <img style="width: 100%;"
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="/>
                          <div class="carousel-caption d-none d-md-block" style="position: absolute;top: 44%;">
                            <h5>PHOTOS COMING SOON</h5>
                          </div>
                      </div>
`;
  }
  
    const rawHtml =

`
		<div class="container">
		<div class="btn-container">
			<input onclick="pageManager('caravans')" type="button" class="btn btn-primary rounded-0" value="Back to Search Results" >
        	<i class="fa fa-long-arrow-right" aria-hidden="true"></i> 
		</div>
		  <div class="row">
            <div class="col-lg-12 col-md-12">
              <div>
                <div class="row col-custom--01">
                  <div id="product-title" class="col-lg-8 product-title">
                    <h2>` + vehicleDetails.title + `</h2> 
                  </div>
                  <div class="col-lg-4">
                    <div class="product-header">
                      <span class="product-price">$` + (+price).toLocaleString() + `</span><br>                                                    
                      <span class="Drive-Away">`+priceType+`</span>                                               
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="gallery-image">
                  <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
                    <div class="carousel-inner">
						` +imgCarouselHTML+ `
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="sr-only">Next</span>
                    </a>
                  </div>  
                </div>
                <div class="vehicle-description">
                  <p>` + vehicleDetails.title + `</p>                            
                  <div style="clear:both;"></div> 
                  <br>
                </div>
                <div class="product-accordion">
                    <div class="accordion-group">
                        <div class="accordion-heading">
                            <span>Caravan Details</span>
                        </div>
                        <div class="accordion-body">
                            <div class="accordion-inner">
                                <table class="product-attribute table table-bordered">
                                    <tbody>
                                      <tr>
                                        <th>Stock Number</th>
                                        <td><b>` + vehicleDetails.stockNumber + `</b></td>
                                      </tr>
                                      <tr>
                                        <th>Reg. Plate</th>
                                        <td><b>` + vehicleDetails.regPlate + `</b></td>
                                      </tr>
                                      <tr class="">
                                        <th>Tare Weight</th>
                                        <td><b>` + vehicleDetails.tare + `KG</b></td>
                                      </tr>
                                      <tr class="">
                                        <th>ATM Weight</th>
                                        <td><b>` + vehicleDetails.atm + `KG</b></td>
                                      </tr>
                                      <tr class="">
                                        <th>Ball Weight</th>
                                        <td><b>` + vehicleDetails.ball + `KG</b></td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
					`+acccessoriesHTML+`
                </div>              
              </div>
            </div>
          </div>
        </div>

`;
  
  return rawHtml;
  
}

function getVehicleAccessoriesHTML(vehicleAccessories) {
 
  if (vehicleAccessories.length === 0) return '';
  
  var accesories = '';
  
  for (i=0; i<=vehicleAccessories.length-1;i+=2) {
   
    try {
      const col1Index = i;
      const col2Index = i + 1;
      
      const col1 = vehicleAccessories[col1Index] ? vehicleAccessories[col1Index] : '';
      const col2 = vehicleAccessories[col2Index] ? vehicleAccessories[col2Index] : '';
      
      
         const newAccessory = 
`
  <tr>
	<td>${col1}</td>
	<td>${col2}</td>
  </tr>
`;
    accesories += newAccessory; 
    }
    catch(err) {
     continue; 
    }
  }
  
  var rawHTML = 
`
<div class="accordion-group">
    <div class="accordion-heading">
        <span>VEHICLE ACCESSORIES</span>
    </div>
    <div class="accordion-body">
        <div class="accordion-inner">
            <table class="product-attribute table table-bordered">
                <tbody>
					`+accesories+`
                </tbody>
            </table>
        </div>
    </div>
</div>

`;
  
  return rawHTML;
}

function goToDetails(vehicleId) {
  pageManager('details');
  renderCaravanDetails(vehicleId);
}

function pageManager(pageId) {
  if (pageId === 'caravans') {
    document.getElementById("detail-container").innerHTML = ``;
	document.getElementById('details').classList.add("c-hide");
    document.getElementById('caravans').classList.remove("c-hide");
    
  } else if (pageId === 'details') {
    document.getElementById('caravans').classList.add("c-hide");
    document.getElementById('details').classList.remove("c-hide");
  }
}

function populateDropdownValues(data) {
  
  const drpTypePlaceHolder = `<option value="" selected>View All Types</option>`;
  document.getElementById("drp-type").innerHTML += drpTypePlaceHolder;
  for (i=0; i < typesFromTemplate.length;i++) {
    const type = typesFromTemplate[i];
    var htmlOptionType = createHtmlDropdown(type, "drp-type"); 
    appendOption("drp-type", type, htmlOptionType);
  }
  
  var htmlOptionPriceMin = populatePriceDrpMin();
  var htmlOptionPriceMax = populatePriceDrpMax();
  document.getElementById("drp-price-min").innerHTML += htmlOptionPriceMin;
  document.getElementById("drp-price-max").innerHTML += htmlOptionPriceMax;
  
  var buildYearMinArr = [];
  var buildYearMaxArr = [];
  
  var promisePopulateDrp = new Promise(function(resolve, reject) {
    for (i = 0; i <= +data.vehicles.count-1; i++) {
      const vehicle = data.vehicles.vehicle[i];
      getVehicleFullDetailsFromCache(vehicle.id).then(function (vehicleDetails) {
        const details = createDetailsObj(vehicleDetails, vehicle.id);

        var htmlOptionMake = createHtmlDropdown(details.make, "drp-make");
        appendOption("drp-make", details.make, htmlOptionMake);

        if (typeFromTemplate === '') {
          var htmlOptionType = createHtmlDropdown(details.type, "drp-type"); 
          appendOption("drp-type", details.type, htmlOptionType);
        }

        var htmlOptionModel = createHtmlDropdown(details.model, "drp-model");
        appendOption("drp-model", details.model, htmlOptionModel);
 
        buildYearMinArr.push(details.buildYear);
        buildYearMaxArr.push(details.buildYear);

      })
      .catch((err) => console.log(err));
    }
    resolve();
  });
  
  promisePopulateDrp
    .then(function() {
        var htmlOptionBuildYearMin = populateBuildYearDrpMin(buildYearMinArr);
    	var htmlOptionBuildYearMax = populateBuildYearDrpMax(buildYearMinArr);
    	document.getElementById("drp-build-year-min").innerHTML += htmlOptionBuildYearMin;
    	document.getElementById("drp-build-year-max").innerHTML += htmlOptionBuildYearMax;
    })
    .catch((err) => console.log(err));
}

function populateBuildYearDrpMin(arr) {
  var uniqArr = [...new Set(arr.filter(Number))]
  var options = '';
  
  uniqArr.sort(function(a, b){return a - b});
  for(i = 0; i<=uniqArr.length-1;i++) {
    const drpHTML = createHtmlDropdown(uniqArr[i], "drp-build-year-min");
    options += drpHTML;
  }
  return options;
}

function populateBuildYearDrpMax(arr) {
  var uniqArr = [...new Set(arr.filter(Number))];
  uniqArr.sort(function(a, b){return b - a});
  var options = '';
  for(i = 0; i<=uniqArr.length-1;i++) {
    const drpHTML = createHtmlDropdown(uniqArr[i], "drp-build-year-min");
    options += drpHTML;
  }
  return options;
}

function populatePriceDrpMin() {
  var options = '';
  for(i = 5000; i <= 55000; i+=5000) {
   const drpHTML = createHtmlDropdown(i, "drp-price-min");
   options += drpHTML;
  }
  return options;
}

function populatePriceDrpMax() {
  var options = '';
  for(i = 55000; i >= 5000; i-=5000) {
    const drpHTML = createHtmlDropdown(i, "drp-price-max");
   options += drpHTML;
  }
  return options;
}

function isOptionExists(selectHtmlId, value) {
  if (document.getElementById(`${selectHtmlId}-${value}`)) {
   return false; 
  }
  
  return true;
}

function appendOption(drpId, value, htmlOption) {
  if (isOptionExists(drpId, value)) {
     document.getElementById(drpId).innerHTML += htmlOption;
  }
}

function createHtmlDropdown(optionValue, drpId) { 
  return `<option id="${drpId}-${optionValue}" value="${optionValue}">${optionValue}</option>`
}

// attach this to search button
function search(paramType = '', paramMake = '') {
 
  var make = document.getElementById('drp-make').value;
  var model = document.getElementById('drp-model').value;
  var type = document.getElementById('drp-type').value;
  var buildMin = document.getElementById('drp-build-year-min').value;
  var buildMax = document.getElementById('drp-build-year-max').value;
  var priceMin = document.getElementById('drp-price-min').value;
  var priceMax = document.getElementById('drp-price-max').value;

  var filter = { 
    make: make,
  	model: model,
    type: type,
    buildMin: buildMin,
    buildMax: buildMax,
    priceMin: priceMin,
    priceMax: priceMax,
  };
  
  if (paramType !== '') {
    filter.type = paramType;
  }
  
  if (paramMake !== '') {
    filter.make = paramMake;
  }
  
  clearProductCards();
  
  hideLoading(false);
  getAllCurrentStocksOfADealership().then(function (data) {
    // populateProductCardsByFilter(data, filter);
    populateProductCardsByFilterSortedByYear(data, filter);
  })
  .then(() => hideLoading())
  .catch((err) => console.log({err}));
}

function hideLoading(hide=true) {
  if (!hide) {
    document.getElementById("loading-wrapper").classList.remove("c-hide");
    return;
  }
  
  document.getElementById("loading-wrapper").classList.add("c-hide");
}

function clearProductCards() {
  document.getElementById("vehicle-container").innerHTML = '';
}


function populateProductCardsByFilter(data, filter) {  
  for (i = 0; i <= +data.vehicles.count-1; i++) {
    const vehicle = data.vehicles.vehicle[i];
    getVehicleFullDetailsFromCache(vehicle.id).then(function (vehicleDetails) {
      if (isIncludedInSearch(filter, vehicleDetails.vehicle)) {
        const details = createDetailsObj(vehicleDetails, vehicle.id);
        var productCard = createProductCard(details);
        document.getElementById("vehicle-container").innerHTML += productCard;
      }
    });
  }
}

function populateProductCardsByFilterSorted(data, filter) {
  for (i = 0; i <= +data.vehicles.count-1; i++) {
    const vehicle = data.vehicles.vehicle[i];
    getVehicleFullDetailsFromCache(vehicle.id).then(function (vehicleDetails) {
      if (isIncludedInSearch(filter, vehicleDetails.vehicle)) {
        const details = createDetailsObj(vehicleDetails, vehicle.id);
      }
    });
  }
}

function populateProductCardsByFilterSortedByYear(data, filter) {
  
  // filter
  const filteredDetails = new Promise(function (resolve, reject) {
    let detailsArr = [];
    for (i = 0; i <= +data.vehicles.count - 1; i++) {
      const vehicle = data.vehicles.vehicle[i];
      getVehicleFullDetailsFromCache(vehicle.id).then(function (vehicleDetails) {
        if (isIncludedInSearch(filter, vehicleDetails.vehicle)) {
          const details = createDetailsObj(vehicleDetails, vehicle.id);
          detailsArr.push(details);
        }
      });
    }
    resolve(detailsArr);
  });
  
  
  // sort by year
  filteredDetails.then(function (details) {
    const sortedByYear = details.sort(function (a,b) {
       return +b.buildYear - +a.buildYear;
    });
    
    for (i = 0; i <= + sortedByYear.length - 1; i++) {
      var productCard = createProductCard(sortedByYear[i]);
      document.getElementById("vehicle-container").innerHTML += productCard;
    }
    
  });
}


function isIncludedInSearch(filter, vehicleDetails){
  return isIncludedInSearchImp(filter, vehicleDetails);
}

function isIncludedInSearchImp(filter, vehicleDetails) {
  if (!isAnyFilterSelected(filter)) {
    return true;
  }

  var arrFilter = [];

  if (filter.type !== '') { 
    arrFilter.push(() => filter.type === vehicleDetails.type);
  }

  if (filter.make !== '') {
    arrFilter.push(() => filter.make === vehicleDetails.make);
  }
  
  if (filter.model !== '') {
    arrFilter.push(() => filter.model === vehicleDetails.model);
  }
  
  if (filter.buildMin !== '' || filter.buildMax !== '') {
    arrFilter.push(() => isWithinRange(+filter.buildMin, +filter.buildMax, +vehicleDetails.buildYear));
  }
  
  if (filter.priceMin !== '' || filter.priceMax !== '') {
    arrFilter.push(() => isWithinRange(+filter.priceMin, +filter.priceMax, +vehicleDetails.driveawayPrice));
  }  
  
  for(i = 0; i <= +arrFilter.length; i++) {
    if (arrFilter[i] === undefined) {
     continue; 
    }
    
    const filterResult = arrFilter[i]();
    if (!filterResult) {
      return false;
    } 
  }

  return true;

}


function isWithinRange(min, max, val) {
  
  	if (min === 0 && max === 0 && val === 0) return false;

    if (+min > 0 && +max == 0) {
        if (+val >= +min) {
            return true;
        }
    } else if (+min == 0 && +max > 0) {
        if (+val <= +max) {
            return true;
        }
    } else {
        if (+val >= +min && +val <= +max) {
            return true;
        }
    }
}

function isAnyFilterSelected(filter) {
  if (filter.type === '' 
    && filter.make === '' 
    && filter.model === '' 
    && filter.buildMin === ''
    && filter.buildMax === ''
    && filter.priceMin === ''
    && filter.priceMax === ''  ) {
    return false;
  }
  return true;
}

function populateProductCards(data) {
  for (i = 0; i <= +data.vehicles.count-1; i++) {
    const vehicle = data.vehicles.vehicle[i];
    getVehicleFullDetailsFromCache(vehicle.id).then(function (vehicleDetails) {
      const details = createDetailsObj(vehicleDetails, vehicle.id);
      var productCard = createProductCard(details);
      document.getElementById("vehicle-container").innerHTML += productCard;
    }); 
  } 
}

function createDetailsObj(vehicleDetails, vehicleId) {
  return {
    regBody1: vehicleDetails.vehicle.body,
    tare: vehicleDetails.vehicle.tare,
    vehicleDesc: vehicleDetails.vehicle.vehicleDesc,
    price: vehicleDetails.vehicle.driveawayPrice,
    atm: vehicleDetails.vehicle.atm,
    ball: vehicleDetails.vehicle.ball,
    type: vehicleDetails.vehicle.class,
    imgUrl: getAVehiclesThumbnailUrl(vehicleId),
    title: vehicleDetails.vehicle.title,  
    id: vehicleId,
    type: vehicleDetails.vehicle.type,
    make: vehicleDetails.vehicle.make,
    model: vehicleDetails.vehicle.model,
    variant: vehicleDetails.vehicle.variant,
    buildYear: vehicleDetails.vehicle.buildYear,
    imgCount: vehicleDetails.vehicle.imgCount,
    egcPrice: vehicleDetails.vehicle.egcPrice,
  }
}

function createProductCard(details) {
  var imgHtml = '<div style="">PHOTOS COMING SOON</div>';
  if (details.imgCount > 0) {
  	imgHtml = `<img class="image" src="` + details.imgUrl + `" loading="lazy" data-lazyload="true">`;
  }
  
  var { price, priceType } = getProductPriceCard(details);
  
  	var productCardHtml =
        
`
			<div id="` + details.id + `" data-type="` + details.type + `" class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
              <div class="box-product">
                <div class="box-resize">
				  <div class="resize-img" onClick="goToDetails('` + details.id + `')" style="cursor: pointer;">
                    ` + imgHtml + `
                  </div>
                </div>
              	<div class="clearfix"></div>
              	<p>` + details.title + `</p>
              	<div class="box-product-info">
                  <div class="box-product-specifications">
                    <div class="d-flex justify-content-center">
                      <div class="col-xs-3">
                        <p><b>Tare Weight</b></p> 
                        <p>` + details.tare + ` KG</p>		                                           
                      </div>
                      <div class="col-xs-3">
                        <p><b>ATM Weight</b></p> 
                        <p>` + details.atm + ` KG</p>		                                            
                      </div>            
                      <div class="col-xs-3 hdf-variant">
                        <p><b>Type</b></p> 
                        <p>` + details.type + `</p>
                      </div>
                      <div class="col-xs-3 hdf-variant">
                        <p><b>Axle</b></p>
                        <p>` + details.regBody1 + `</p>
                      </div>                      
                    </div>
                  </div>
                  <div class="box-product-description px-4">
					`+ replaceSpecialCharacters(details.vehicleDesc) +`                                                                      
                  </div>
                  <div class="clearfix"></div>
                  <div class="box-product-price">
                    <div class="d-flex justify-content-between">
                      <div class="col-xs-6 cl-price">
                        <div class="default-price"> 
                          <h4>$` + price + `</h4>
                          <span class="rep-text-lbl">` + priceType + `</span>
                        </div>
                      </div>
                      <div class="col-xs-6">
                        <div class="more-info" onClick="goToDetails('` + details.id + `')">
                          MORE DETAILS
                        </div>
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
			</div>
`;

    return productCardHtml;
}
function getProductPriceCard(details) {
  
  var price = details.price;
  var priceType = 'Drive Away';
  
  if (details.price.length === 0) {
    price = details.egcPrice;
    priceType = 'Excl. Govt. Charges';
  }   
  
  price = (+price).toLocaleString();
  
  return {
    price: price,
    priceType: priceType
  };
}

function replaceSpecialCharacters(str) {
    var newStr = str
        .replace(/&amp;/g, `&`)
        .replace(/&gt;/g, `>`)
        .replace(/&lt;/g, `<`)
        .replace(/&quot;/g, `"`);

    return newStr;
}

// SERVICE
function getAllCurrentStocksFromCache() {  
  return new Promise(function(resolve, reject) {           
    var obj = JSON.parse(sessionStorage['allCurrentStock']);
    resolve(obj);
  });
}

function getVehicleFullDetailsFromCache(id) {
  return new Promise(function(resolve, reject) {
    var obj = JSON.parse(sessionStorage[`vehicleFullDetails-${id}`]);
    resolve(obj);
  });
}

// CACHE SERVICE
function populateVehiclesSessionStorage(renderCallBack = () => {}) {
  if (isVehiclesSessionStoragePopulated())
  {
    renderCallBack();
    return; 
  }
  getAllCurrentStocksOfADealership().then(function(data) {
    sessionStorage[`allCurrentStock`] = JSON.stringify(data);
    for (i = 0; i <= +data.vehicles.count-1; i++) {
    const vehicle = data.vehicles.vehicle[i];
      getVehicleFullDetails(vehicle.id).then(function (vehicleDetails) {
        sessionStorage[`vehicleFullDetails-${vehicle.id}`] = JSON.stringify(vehicleDetails);
      }); 
    }
    renderCallBack();
  })
  .catch((error) => console.log(error)); 
}

function isVehiclesSessionStoragePopulated() {
  if (sessionStorage[`allCurrentStock`] === null || sessionStorage[`allCurrentStock`] === undefined)
  {
    return false; 
  }
    
  return true;
}

// API SERVICES

function getAllCurrentStocksOfADealership(countOnly = false) {
    return new Promise(function (resolve, reject) {
        var url = `http://service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_get_stocks.asp?token=${token}`;

        if (countOnly) {
            url = `${url}&&count_only=yes`;
        }

        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var document = xhttp.responseXML;
                var status = document.getElementsByTagName('status')[0].childNodes[0].nodeValue;
                var vehicleCount = document.getElementsByTagName('vehicles')[0].getAttribute('count');
                var vehicles = [];
                for (i = 0; i < vehicleCount; i++) {
                    vehicles.push(
                        {
                            id: document.getElementsByTagName('vehicle')[i].getAttribute('id'),
                            lastUpdated: document.getElementsByTagName('vehicle')[i].getAttribute('last-updated'),
                            stockNumber: document.getElementsByTagName('vehicle')[i].getAttribute('stock-number'),
                            class: document.getElementsByTagName('vehicle')[i].getAttribute('class'),
                            imageCount: document.getElementsByTagName('vehicle')[i].getAttribute('image-count'),
                            documentCount: document.getElementsByTagName('vehicle')[i].getAttribute('document-count'),
                            onSale: document.getElementsByTagName('vehicle')[i].getAttribute('on-sale'),
                            dealerId: document.getElementsByTagName('vehicle')[i].getAttribute('dealer-id'),
                            branchId: document.getElementsByTagName('vehicle')[i].getAttribute('branch-id'),
                            category: document.getElementsByTagName('vehicle')[i].getAttribute('category'),
                            xciteDealerId: document.getElementsByTagName('vehicle')[i].getAttribute('xcite-dealer-id'),
                            selfClosing: document.getElementsByTagName('vehicle')[i].getAttribute('self-closing'),
                        }
                    )
                }

                var obj = {
                    status: status,
                    vehicles: {
                        count: vehicleCount,
                        vehicle: vehicles
                    }
                };
                resolve(obj);
            }
        };
        xhttp.open("GET", url, true);
        xhttp.send();
    });
}


function getProductTitleFromDesc(vehicleDesc) {
  var title = vehicleDesc.split('&lt')[0];
  if (title.length > 40) {
    title = title.substring(1, 40);
  }
  return title;
}

function getProductTitleFromAttr(details) {
  // buildYear + make + model + variant + body
}

function getVehicleFullDetails(vehicleId, includeAllImg = false) {
    return new Promise(function (resolve, reject) {
        var url = `http://service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_get_vehicle.asp?vehicle_id=${vehicleId}&pic_width=450&pic_limit=30&pic_quality=70&pic_summary=yes`;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var parser = new DOMParser();
                var document = parser.parseFromString(xhttp.responseText, 'text/xml');
              
                if(document.getElementsByTagName('parsererror').length > 0) {
                 return; 
                }
              
                var status = document.getElementsByTagName('status')[0].childNodes[0].nodeValue;
                var vehicleDesc = document.getElementsByTagName('vehicle')[0].getAttribute('vehicle-desc');
                var title = getProductTitleFromDesc(vehicleDesc);
                var vehicle = {
                    dealerId: document.getElementsByTagName('vehicle')[0].getAttribute('dealer-id'),
                    xciteDealerId: document.getElementsByTagName('vehicle')[0].getAttribute('xcite-dealer-id'),
                    id: document.getElementsByTagName('vehicle')[0].getAttribute('id'),
                    stockNumber: document.getElementsByTagName('vehicle')[0].getAttribute('stock-number'),
                    askingPrice: document.getElementsByTagName('vehicle')[0].getAttribute('asking-price'),
                    vehicleDesc: vehicleDesc,
                    driveawayPrice: document.getElementsByTagName('vehicle')[0].getAttribute('driveaway-price'),
                    egcPrice: document.getElementsByTagName('vehicle')[0].getAttribute('egc-price'),
                    tare: document.getElementsByTagName('vehicle')[0].getAttribute('tare'),
                    atm: document.getElementsByTagName('vehicle')[0].getAttribute('atm'),
                    ball: document.getElementsByTagName('vehicle')[0].getAttribute('ball'),
                    class: document.getElementsByTagName('vehicle')[0].getAttribute('class'),
                    title: title,
                    type: document.getElementsByTagName('vehicle')[0].getAttribute('type'),
                    make: document.getElementsByTagName('model')[0].getAttribute('make'),
                    model: document.getElementsByTagName('model')[0].getAttribute('model'),
                    variant: document.getElementsByTagName('model')[0].getAttribute('variant'),
                    series: document.getElementsByTagName('model')[0].getAttribute('series'),
                    body: document.getElementsByTagName('model')[0].getAttribute('body'),
                    buildYear: document.getElementsByTagName('dates')[0].getAttribute('build-year'),
                    regPlate: document.getElementsByTagName('registration')[0].getAttribute('plate'),
                    imgCount: document.getElementsByTagName('picture').length,
                }
              
                var accessories = [];
                const accessoryCount = document.getElementsByTagName('accessory').length;
                for (i = 0; i <= accessoryCount-1; i++) {
					accessories.push(document.getElementsByTagName('accessory')[i].getAttribute('desc'));
                }

                if (title.length === 0) {
                  vehicle.title = `${vehicle.buildYear} ${vehicle.make} ${vehicle.model} ${vehicle.variant} ${vehicle.body}`;
                }

                var obj = {
                  status: status,
                  vehicle: vehicle,
                  accessories: accessories,
                };

                if (includeAllImg) {
                
                var imgCount = document.getElementsByTagName('picture').length;
                
                var imageUrls = [];
                for(i = 0; i<=imgCount - 1; i++ ) {
                  const pic_id = document.getElementsByTagName('picture')[i].getAttribute('pic-id');                  
                  imageUrls.push(getVehiclePhotoUrl(pic_id));                   
                } 
                
                var images = {
                  
                  count: imgCount,
                  images: imageUrls
                };
                
                obj = {...obj, images: images };
                
              }                            

              resolve(obj);
            }
        };
        xhttp.open("GET", url, true);
        xhttp.send();
    });
}

// returns with xml error
// can't execute, encounters cors issue
function getAllCurrentStocksOfADealershipWithVehicleDetails() {
    return new Promise(function (resolve, reject) {
      	var url = `http://service.ultimate.net.au/ubs_mtaq/member/upload/ubs_mtaq_get_stock_details.asp?token=${token}`;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var document = xhttp.responseXML;
                var status = document.getElementsByTagName('status')[0].childNodes[0].nodeValue;
                var vehicleCount = document.getElementsByTagName('vehicles')[0].getAttribute('count');

                var vehicles = [];
                for (i = 0; i < vehicleCount - 1; i++) {
                    var status = document.getElementsByTagName('status')[0].childNodes[0].nodeValue;
                	var vehicleDesc = document.getElementsByTagName('vehicle')[0].getAttribute('vehicle-desc');
                    vehicles.push(
                        {
                          id: document.getElementsByTagName('vehicle')[i].getAttribute('id'),
                          dealerId: document.getElementsByTagName('vehicle')[0].getAttribute('dealer-id'),
                          xciteDealerId: document.getElementsByTagName('vehicle')[0].getAttribute('xcite-dealer-id'),
                          id: document.getElementsByTagName('vehicle')[0].getAttribute('id'),
                          stockNumber: document.getElementsByTagName('vehicle')[0].getAttribute('stock-number'),
                          askingPrice: document.getElementsByTagName('vehicle')[0].getAttribute('asking-price'),
                          vehicleDesc: vehicleDesc,
                          driveawayPrice: document.getElementsByTagName('vehicle')[0].getAttribute('driveaway-price'),
                          tare: document.getElementsByTagName('vehicle')[0].getAttribute('tare'),
                          atm: document.getElementsByTagName('vehicle')[0].getAttribute('atm'),
                          ball: document.getElementsByTagName('vehicle')[0].getAttribute('ball'),
                          class: document.getElementsByTagName('vehicle')[0].getAttribute('class'),
                          body: document.getElementsByTagName('model')[0].getAttribute('body'),
                          title: title,
                        }
                    )
                }

                var obj = {
                    status: status,
                    vehicles: {
                        count: vehicleCount,
                        vehicle: vehicles
                    }
                };    
                resolve(obj);
            }
        };
        xhttp.open("GET", url, true);
        xhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
        xhttp.setRequestHeader('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
        xhttp.setRequestHeader('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
        xhttp.send();
    });
}

function getAVehiclesThumbnail(vehicleId) {
    return new Promise(function (resolve, reject) {
        var url = `http://service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_get_thumbnail.asp?vehicle_id=${vehicleId}&w=200&h=130`;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                resolve(xhttp.responseURL);
            }
        };
        xhttp.open("GET", url, true);
        xhttp.send();
    });
}

function getAVehiclesThumbnailUrl(vehicleId) {
    return `//service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_get_thumbnail.asp?vehicle_id=${vehicleId}`;
}

function getAVehiclesThumbnailUrlFullSize(vehicleId) {
    return `//service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_get_thumbnail.asp?vehicle_id=${vehicleId}`;
}

function getVehiclePhotoUrl(picId) {
  return `//service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_show_photo.asp?pic_id=${picId}`; 
}

function getDocument(docId) {
    return new Promise(function (resolve, reject) {
        var url = `http://service.ultimate.net.au/ubs_mtaq/member/ws/ubs_mtaq_show_document.asp?doc_id=${docId}`;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                resolve(xhttp.responseText);
            }
        };
        xhttp.open("GET", url, true);
        xhttp.send();
    });
}